import React from 'react'
import Button from '@dashboard/components/Button'

import css from './styles.module.scss'

interface Props {
  wallContent: JSX.Element | string
  paywallButtonLink: string
  paywallButtonText: string
  blurHeight?: number
  children: JSX.Element | string
}

interface State {}

class PaywalledContent extends React.Component<Props, State> {
  render() {
    const {
      children,
      wallContent,
      paywallButtonLink,
      paywallButtonText,
      blurHeight,
    } = this.props
    const style = {
      height: `${blurHeight || 85}px`,
    }

    return (
      <div className={css.wrapper}>
        <div className={css.paywalled} style={style}>
          {children}
        </div>
        <div className={css.paywall}>
          <div className={css.circle}>
            <img src="/static/share/images/group_fit.svg" />
          </div>
          <div className={css.paywallText}>{wallContent}</div>

          <Button href={paywallButtonLink}>{paywallButtonText}</Button>
        </div>
      </div>
    )
  }
}

export default PaywalledContent
